const state = {
  inboxInProccess: [],
};

export default state;
